import { csvw_url } from "../../components/config";

export default {
  work: {
    imageurl: require("../../assets/meb/imgs/work/carBG@2x.png"),
    imageurlMobile: require("../../assets/meb/imgs/work/carBG@2x.png"),
    list: [
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/work/cjgyTu1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/work/cjgyTu1@2x.png"),
        title: "冲压车间",
        dec:
          "冲压车间建筑面积约31680㎡，主要生产单个车型的19个大型内外覆盖件。车间拥有两条世界先进的舒勒伺服高速压机线，并首次采用二层冲压件仓库，使用AGV与升降机对接实现零件在两层仓库之间的运输。",
        imgs: [],
        tourl: "/subject/workshop?index=1"
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/work/cjgyTu2@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/work/cjgyTu2@2x.png"),
        title: "车身车间",
        dec:
          "车身车间分2层结构，一楼主要是门盖、底板1和装配线。二楼主要是侧围、底板2、总拼以及报交线。车身车间的设计生产能力是60JPH，即每小时可以完成60台白车身，年产量30万台。<br />车间采用了大量智能制造先进新技术，其中At-line在线测量、EMS空中输送、机器人全自动拧紧工艺、CMT+冷金属过渡焊接工艺均是上汽大众首次使用。此外车间还拥有大众汽车集团工厂中速度最高的激光焊以及上汽大众最长的车间装配线，保证输送过程零件的一致性。",
        imgs: [],
        tourl: "/subject/workshop?index=2"
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/work/cjgyTu3@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/work/cjgyTu3@2x.png"),
        title: "油漆车间",
        dec:
          "120JPH油漆车间是大众汽车集团全球首创的高产能油漆车间，采用多项新技术，运用全新的环保工艺与智能技术，同时供应MEB工厂与安亭汽车三厂两个厂区。相较于传统的两个60JPH标准化油漆车间，节省建筑面积12%。",
        imgs: [],
        tourl: "/subject/workshop?index=3"
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/work/cjgyTu4@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/work/cjgyTu4@2x.png"),
        title: "总装车间",
        dec:
          "总装车间设计生产能力为60JPH，达产后完成30万的年生产量。它是目前大众汽车集团自动化率最高的量产车型总装车间，自动化率达26.2%，模块化程度和柔性更高。车间二层平台有完备的输送线，车身通过连廊从油漆车间输送至总装车间；电池包则通过输送链到达总装车间二层平台，通过升降机下至底盘预装线。",
        imgs: [],
        tourl: "/subject/workshop?index=4"
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/work/cjgyTu5@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/work/cjgyTu5@2x.png"),
        title: "电池车间",
        dec:
          "电池车间是上汽大众首个全铝电池壳体自制与电池包装配车间，规划年产能30万台。车间有两层的厂房。二楼是电池壳体线。壳体成品通过升降机自动输送到一楼的电池装配线。电池包完成装配后，通过升降机自动输送到二楼的电池包调序中心，每个电池包与车壳匹配后，通过连廊自动输送到总装车间。",
        imgs: [],
        tourl: "/subject/workshop?index=5"
      },
    ]
  },
  workshop1: {
    videourl: csvw_url + "/u/cms/www/202010/22121041G4IG.mp4",
    videoimg: require("../../assets/meb/imgs/cy/cyBanner@2x.png"),
    videoimgMobile: require("../../assets/meb/imgsMobile/cy/mCyBanner@2x.png"),
    list: [
      {
        videourl: csvw_url + "/u/cms/www/202010/221223357H8P.mp4",
        videoimg: require("../../assets/meb/imgs/cy/CYtu1@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cy/CYtu1@2x.png"),
        title: "先进的舒勒伺服高速压机线",
        dec:
          "两条压机线总吨位达6900t，最高冲次均可达18次/min。采用最先进的自动化换模和Tooling更换系统，5分钟内可完成整线换模，提升生产效率与精度。",
        imgs: [
          require("../../assets/meb/imgs/cy/CYtu2@2x.png"),
          require("../../assets/meb/imgs/cy/CYtu3@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22122245S39j.mp4",
        videoimg: require("../../assets/meb/imgs/cy/CYtu4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cy/CYtu4@2x.png"),
        title: "环保降噪",
        dec:
          "压机线上使用了舒勒第二代整体隔音罩覆盖，最高可降噪16dB(A)；车间废料回收间采用内部网孔板隔音技术，降低废料间噪音，有效改善员工作业环境。",
        imgs: []
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22122650G632.mp4",
        videoimg: require("../../assets/meb/imgs/cy/CYtu5@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cy/CYtu5@2x.png"),
        title: "采用智能化设备，提升冲压效率",
        dec:
          "首次将重载型全向AGV应用到零件下线运输中，最大载重达1.5T，从冲压线下线到零件存放库区整个过程不再需要叉车,还采用了三层模具吊、自动运行平板车等智能化设备，提高了运行效率。",
        imgs: [
          require("../../assets/meb/imgs/cy/CYtu6@2x.png"),
          require("../../assets/meb/imgs/cy/CYtu7@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/221225082Y52.mp4",
        videoimg: require("../../assets/meb/imgs/cy/CYtu8@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cy/CYtu8@2x.png"),
        title: "使用智能化软件系统，提升运营管理效率",
        dec:
          "采用了TPMS系统、高级计划排程系统（APS），提升模具管理、仓库管理的效率， 加上舒勒压机线使用的BDE系统、仓库零件管理使用条码入库系统，实现仓库的智能化管理。",
        imgs: []
      }
    ]
  },
  workshop2: {
    videourl: csvw_url + "/u/cms/www/202010/2212140458F5.mp4",
    videoimg: require("../../assets/meb/imgs/cs/csBanner@2x.png"),
    videoimgMobile: require("../../assets/meb/imgsMobile/cs/mCsBanner@2x.png"),
    list: [
      {
        videourl: csvw_url + "/u/cms/www/202010/22122812QA3k.mp4",
        videoimg: require("../../assets/meb/imgs/cs/CStu1@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cs/CStu1@2x.png"),
        title: "高自动化率，实现精益生产",
        dec:
          "车间拥有机器人数量946台，自动化率高达84%，是目前上汽大众自动化率最高的车身车间。",
        imgs: []
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/2212303257T4.mp4",
        videoimg: require("../../assets/meb/imgs/cs/CStu4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cs/CStu4@2x.png"),
        title: "上汽大众最长的车间装配线&空中EMS",
        dec:
          "上汽大众最长的车间装配线长达150m，与空中EMS共同使用，实现零件自动化搬运，减少人工搬运强度，保证输送过程中的零件一致性。首次采用EMS电动单轨输送系统，是上汽大众最长的EMS输送存储线总长6000m，最多可储存180套侧围和180套门盖总成零件，实现6车型的识别和搬运功能，也是全球首次实现门盖总成JIS自动化供货模式。",
        imgs: [
          require("../../assets/meb/imgs/cs/CStu2@2x.png"),
          require("../../assets/meb/imgs/cs/CStu3@2x.png")
        ]
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/cs/CStu5@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/cs/CStu5@2x.png"),
        title: "At-line在线测量",
        dec:
          "大众汽车集团全球首个At-line测量工位。车身车间有 2个At-line在线测量工位，8台测量机器人对白车身的零部件和关键部位实行100%视觉在线检查，通过激光测量传感器、图像处理、温度补偿以及计算机控制等技术实现物体空间尺寸的精密测量，重复精度高达0.2mm。同时结合工厂智能制造系统，技术员可以网上直接看到质量状态，及时跟踪优化，实现质量状态云端存储分析、自动网联化，大大提升最终产品质量及稳定性。",
        imgs: []
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/cs/CStu7@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/cs/CStu7@2x.png"),
        title: "白车身柔性总拼焊装SVW Framer&自动拧紧",
        dec:
          "SVW Framer是上汽大众自主开发、自主享有知识产权的柔性系统，可支持6种车型生产，最高可扩展至8种车型生产，为未来生产奠定了扎实的基础。首次采用机器人全自动拧紧工艺，实现智能自动化生产。自主开发螺栓送/取钉技术，在开发环节可规避长尺寸链错孔的制造性风险；生产过程中实现螺栓拧紧扭矩合格率100%，增加产品质量稳定性。",
        imgs: [
          require("../../assets/meb/imgs/cs/CStu6@2x.png"),
          require("../../assets/meb/imgs/cs/CStu6 拷贝@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22123527k8Vw.mp4",
        videoimg: require("../../assets/meb/imgs/cs/CStu8@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/cs/CStu8@2x.png"),
        title: "先进焊接技术，造就高强度车身",
        dec:
          "高密度补焊，可适用不同车型，无需切换焊枪，焊接能力提升3倍。车间现有14台焊接机器人，未来可扩展至16台。车身车间采用的高速激光焊目前速度可达110mm/s，是大众汽车集团工厂中速度最高的激光焊。CMT+冷金属过渡焊接是上汽大众首次采用CMT+工艺的车间。CMT+比普通CMT焊接温度更低，热变形更小。焊接过程可达每分钟70次的抽拉丝速度，使焊缝的成型更美观。",
        imgs: [
          require("../../assets/meb/imgs/cs/CStu9@2x.png"),
          require("../../assets/meb/imgs/cs/CStu10@2x.png")
        ]
      }
    ]
  },
  workshop3: {
    videourl: csvw_url + "/u/cms/www/202010/22121626DsMK.mp4",
    videoimg: require("../../assets/meb/imgs/yq/yqBanner@2x.png"),
    videoimgMobile: require("../../assets/meb/imgsMobile/yq/mYqBanner@2x.png"),
    list: [
      {
        videourl: csvw_url + "/u/cms/www/202010/221236367818.mp4",
        videoimg: require("../../assets/meb/imgs/yq/YQtu1@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/yq/YQtu1@2x.png"),
        title: "全球首创120JPH油漆车间",
        dec:
          "油漆车间有7大工艺，每小时可生产120台车，是标准化车间的2倍，并且设备总量是标准化油漆车间的2.5倍，自动化率达到73%，是上汽大众自动率最高的油漆车间。未来可生产MQB\\MLB\\MEB三个平台的车型共12款车型，是全球可产车型数最多、色彩最多的油漆车间。",
        imgs: [
          require("../../assets/meb/imgs/yq/YQtu2@2x.png"),
          require("../../assets/meb/imgs/yq/YQtu3@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/221238170714.mp4",
        videoimg: require("../../assets/meb/imgs/yq/YQtu4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/yq/YQtu4@2x.png"),
        title: "更多智能科技，提升喷涂效率和质量",
        dec:
          "为支持车间12款车型的生产制造，上汽大众首次使用了快速换漆系统，并且将油漆缺陷自动检测系统取代人工缺陷检查，大大提升了效率与质量。",
        imgs: []
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/yq/YQtu5@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/yq/YQtu5@2x.png"),
        title: "智能管理，提升喷涂效率和质量",
        dec:
          "智能中控室系统对设备进行智能管理，使用全旋反向浸渍输送Rodip设备，自动门板喷蜡机器人，防腐蚀性能更加优良，并且通过使用水性可喷涂阻尼垫材料取代沥青阻尼垫材料，实现同等厚度条件下减重约40%。",
        imgs: [
          require("../../assets/meb/imgs/yq/YQtu6@2x.png"),
          require("../../assets/meb/imgs/yq/YQtu7@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/2212392738R1.mp4",
        videoimg: require("../../assets/meb/imgs/yq/YQtu8@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/yq/YQtu8@2x.png"),
        title: "环保科技",
        dec:
          "预处理工艺中，通过将硅烷薄膜技术替代传统的锌系磷化技术，可令镍排放指标下降十倍，并且采用了文丘里干式漆雾吸收系统，不仅可避免自来水的损耗和废水的产生，还不产生有害废弃物，还采用了智慧烘房技术，其智能控制模块能根据烘房内产品车数量的变化，计算并调整燃烧炉实时功率。",
        imgs: []
      }
    ]
  },
  workshop4: {
    videourl: csvw_url + "/u/cms/www/202010/221218149tqJ.mp4",
    videoimg: require("../../assets/meb/imgs/zz/zzBanner@2x.png"),
    videoimgMobile: require("../../assets/meb/imgsMobile/zz/mZZBanner@2x.png"),
    list: [
      {
        videourl: csvw_url + "/u/cms/www/202010/2212415585mW.mp4",
        videoimg: require("../../assets/meb/imgs/zz/ZZtu1@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/zz/ZZtu1@2x.png"),
        title: "高自动化率，精益生产标杆",
        dec:
          "总装车间采用上汽大众首个全自动合装平台，全程实现无人化，还采用了大众汽车集团全球首次应用的技术全自动仪表安装机械手，自动化率达到26.2%，是目前上汽大众自动化率最高的总装车间。",
        imgs: [
          require("../../assets/meb/imgs/zz/ZZtu2@2x.png"),
          require("../../assets/meb/imgs/zz/ZZtu3@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22124301380G.mp4",
        videoimg: require("../../assets/meb/imgs/zz/ZZtu4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/zz/ZZtu4@2x.png"),
        title: "大量运用AGV",
        dec:
          "大量运用AGV小车，总装车间内有2种AGV小车运作，包括物流AGV，主要用于物流区向生产线工位运送物料；工艺AGV，主要用于底盘预装工艺输送，和自动化安装工位高度融合。",
        imgs: []
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/zz/ZZtu5@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/zz/ZZtu5@2x.png"),
        title: "领先智能制造技术",
        dec:
          "运用视觉导引定位实现自动抓取和安装，其抓取精度达+/-0.5mm。运用57把无线高精枪用于拧紧工序。它的重量更轻且不受传统的电线电缆约束，避免了电缆拖曳，降低劳动强度与风险。全球首次应用TDA 车门头道密封技术，创新性地利用视觉识别来识别车门的偏移量，引导机器人自动取料、黏贴、剪切、打孔。",
        imgs: [
          require("../../assets/meb/imgs/zz/ZZtu6@2x.png"),
          require("../../assets/meb/imgs/zz/ZZtu7@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22124047B2M7.mp4",
        videoimg: require("../../assets/meb/imgs/zz/ZZtu8@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/zz/ZZtu8@2x.png"),
        title: "保证下线车质量",
        dec:
          "下线车通过首次采用的双灯箱形式灯光检测、非接触式激光测量以及开放式/透明式的转鼓房，在保证车轮精确定位的同时，进行ABS、ESP、制动力等多项测试。此外，下线车还会在全长712米的9种测试道路进行路试测试，在路试结束后将对车辆进行密封性测试和清洁。",
        imgs: []
      }
    ]
  },
  workshop5: {
    videourl: csvw_url + "/u/cms/www/202010/221221187DsL.mp4",
    videoimg: require("../../assets/meb/imgs/dc/dcBanner@2x.png"),
    videoimgMobile: require("../../assets/meb/imgsMobile/dc/mDcBanner 拷贝@2x.png"),
    list: [
      {
        videourl: csvw_url + "/u/cms/www/202010/22124633A255.mp4",
        videoimg: require("../../assets/meb/imgs/dc/DCtu1@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/dc/DCtu1@2x.png"),
        title: "首次自制铝制电池壳体",
        dec:
          "既是目前唯一采用JIS排序也是首个即时生产拉动式的电池车间，共有壳体和装配两条生产线，拥有超过138台机器人，用于生产MEB平台的两种铝质电池壳体和三款电池包，课题生产线自动化率达88%、装配线自动化率达78%，并且作为电池装配首次与总装车间直接耦合联接，将以60JPH的生产速度向总装车间输送电池包。",
        imgs: []
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/22124436vy8H.mp4",
        videoimg: require("../../assets/meb/imgs/dc/DCtu4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/dc/DCtu4@2x.png"),
        title: "“上汽大众解决方案”",
        dec:
          "电池模组入箱时，底部水冷板支撑设计是MEB项目“上海工厂解决方案”的一个案例。采用“活动支撑板”方案有效适应电池壳体“大尺寸易变形零件”的特性。人工装配工位的电池包和AGV小车分离设计是MEB项目又一个“上海工厂解决方案”。采用66°倾斜辊道装配线，更符合人机工程，保证装配质量稳定。",
        imgs: [
          require("../../assets/meb/imgs/dc/DCtu2@2x.png"),
          require("../../assets/meb/imgs/dc/DCtu3@2x.png")
        ]
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/221245402bjq.mp4",
        videoimg: require("../../assets/meb/imgs/dc/DCtu5@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/dc/DCtu5@2x.png"),
        title: "保障电池包产品稳定性和质量安全",
        dec:
          "在电池车间，上汽大众首次自制铝制壳体。车间应用了包含铝材MIG焊接、RIVTAC铆接、设计冷却工位、采用Micro-Mig焊接等全新工艺，提升精度控制，保障产品质量。在焊接、涂胶、测试三大核心工艺中，采用自动检测机器人对焊缝、尺寸、涂胶、气密性等进行实时监控和测量，确保电池包产品稳定性和质量安全。",
        imgs: []
      },
      {
        videourl: "",
        videoimg: "",
        imageurl: require("../../assets/meb/imgs/dc/DCtu8@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/dc/DCtu8@2x.png"),
        title: "保障热管理能力",
        dec:
          "车间生产的电池包通过了338项严苛测试，远高于国标测试要求。上汽大众还自主设计了整套热量控制系统，极端情况下可以保护驾乘者安全。电池包长寿命性能设计，远高于8年（12万公里）使用寿命。电池还使用新的导热胶工艺，拥有更好的界面填充能力、更少的界面气泡、更好的间隙适用性，使MEB电池包具备更优异的热管理能力。",
        imgs: [
          require("../../assets/meb/imgs/dc/DCtu6@2x.png"),
          require("../../assets/meb/imgs/dc/DCtu7@2x.png")
        ]
      }
    ]
  },
  // 现场直击
  scene: {
    imageurl: require("../../assets/meb/imgs/xczj/xczjBanner@2x.png"),
    imageurlMobile: require("../../assets/meb/imgsMobile/xczj/mXcBanner@2x.png"),
    lbList: [
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu1.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu1.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu3@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu3.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu3.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu4@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu4.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu4.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu2@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu2.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu2.jpg"),
      },
      // 二组
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu5@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu5.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu5.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu7@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu7.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu7.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu8@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu8.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu8.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu6@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu6.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu6.jpg"),
      },
      // 三组
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu9@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu9.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu9.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu11@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu11.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu11.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu12@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu12.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu12.jpg"),
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/LbTu10@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/cLbtu10.jpg"),
        imageurlbig: require("../../assets/meb/imgs/xczj/cLbtu10.jpg"),
      },
    ],
    list: [
      {
        imageurl: require("../../assets/meb/imgs/xczj/Leader1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/Leader1@2x.png"),
        title: "潘为达先生 Mr. Powels",
        subtitle: "上汽大众第一副总经理兼商务执行副总经理",
        subtitleEn: "First Vice President & Commercial Executive Vice President of SAIC VOLKSWAGEN AUTOMOTIVE CO., LTD.",
        dec:
          "这座工厂堪称大众汽车集团全球范围内智能化管理、低碳化运营的标杆工厂。它采用了大众汽车集团最先进的数字化生产技术，实现数据协同和智慧生产；集成了28项节能环保措施，实现单车二氧化碳排放减少60%。新工厂的规划年产能达到30万辆，是大众汽车集团全球首个专为MEB平台车型生产而新建的工厂。<br />我们成千上万员工辛勤工作，最终让我们的愿景变为现实：为所有中国消费者打造高品质、经济适中、科技领先以及可靠的电动出行。",
        decEn: "Globally, this facility is VOLKSWAGEN's benchmark factory in smart management and low-carbon operation. It applies VOLKSWAGEN's cutting-edge digital production technology achieving data collaboration and smart production. Also, it integrates 28 energy conservation and eco-friendly measures to reach a carbon emission reduction of 60% per vehicle produced. The MEB plant has an annual production capacity of 300 thousand units and is the first factory built for producing specifically and only MEB models.<br />Behind all these achievements, we see years of dedication from tens of thousands of our employees. It is your efforts that turn our vision into reality—providing Chinese customers with high-quality, affordable, cutting-edge and reliable EV experience.",
        imgs: []
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/Leader2@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/Leader2@2x.png"),
        title: "陈贤章先生 Mr. Chen Xianzhang",
        subtitle: "上汽大众总经理",
        subtitleEn: "President of SAIC VOLKSWAGEN AUTOMOTIVE CO., LTD.",
        dec:
          "ID.4 X是基于MEB纯电动车平台打造的ID系列车型在中国市场的首秀，它不仅仅是一款新车，我们同时也向大家展示一个全新的大众汽车新能源汽车品牌，一种新的移动出行理念；同时我们也期待，ID.4 X能成为上汽大众把电动汽车从小众带向主流的成功开端，成为大家的日常交通工具。<br />今天，ID.4 X的投产也是上汽大众开启电动化攻势的里程碑。<br />2021年，基于MEB平台，我们还将在这个新工厂陆续投产多款大众品牌、奥迪品牌的纯电动汽车，覆盖不同的细分市场。在主流电动车市场上，我们将展示上汽大众在创新、技术和质量方面的优势，致力于打造中国消费者首选的新能源汽车品牌。",
        decEn: "ID. 4 X is the debut of the MEB EV platform based ID. family on the Chinese market. It is not only a new car but also our wish to introduce a brand new EV product line of VOLKSWAGEN ,a new idea of travel. Meanwhile, we hope that ID. 4 X will uplift EV from the choice of the few to the choice of the many and make it an everyday transport for everyone. <br />Today, with ID.4 X put into production,SAIC VOLKSWAGEN turns on a new chapter of the company's electric revolution. <br />In 2021,based on the MEB platform, we will continue to launch the production of new models at this factory, which include different classes and forms of EVs from VOLKSWAGEN and AUDI to cover different market segments. In this way, we will exhibit SAIC VOLKSWAGEN's advantages on innovation, technology and quality to the mainstream EV market to become the first choice of Chinese consumers.",
        imgs: []
      },
      {
        imageurl: require("../../assets/meb/imgs/xczj/Leader3@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/xczj/Leader3@2x.png"),
        title: "王晓秋先生 Mr. Wang Xiaoqiu",
        subtitle: "上海汽车集团股份有限公司总裁 ",
        subtitleEn: "President of SAIC Motor Corporation Limited",
        dec:
          "希望以此次ID.4 X投产上市为新起点，进一步深化我们与大众汽车集团在电动化、智能网联化和品牌高端化等方面的战略合作，让更多具有全球领先水平的前瞻性技术实现落地，合力推动上汽大众加快创新发展和业务的转型升级，在世界汽车工业百年未有之大变局中，抢占先机、开辟新局，奋力争当新时代改革创新发展的新标杆，为助力打响“上海制造”品牌，推动上海经济社会高质量发展，作出新的更大贡献。",
        decEn: "We hope that the launch of ID.4 X will promote our cooperation with VOLKSWAGEN Group in terms of electrification, intelligent interconnectivity, and the brand's high-end strategy. Together, we will strive for the landing and application of cutting-edge technology in SAIC VOLKSWAGEN to accelerate its innovative development and transformation. Only in this way, can SAIC VOLKSWAGEN seize the opportunity, pave a new path, and become the new benchmark for reform and innovative development of the new era. All these are to contribute more to the reputation of “Made in Shanghai” as well as the high-quality development of the Shanghai economy and society.",
        imgs: []
      },
      {
        videourl: csvw_url + "/u/cms/www/202010/28114238y5cW.mp4",
        videoimg: require("../../assets/meb/imgs/xczj/Leader4@2x.png"),
        videoimgMobile: require("../../assets/meb/imgs/xczj/Leader4@2x.png"),
        imageurl: "",
        imageurlMobile: "",
        title: "贝瑞德先生 Mr. Ralf Brandstaetter",
        subtitle: "大众汽车乘用车品牌管理董事会主席",
        subtitleEn: "Chairman of the Board of Management of Volkswagen passenger cars",
        dec: "",
        decEn: "",
        imgs: []
      },

    ],
    list2: [
      {
        imageurl: require("../../assets/meb/imgs/xczj/XczjNew1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgsMobile/xczj/mNew1@2x.png"),
        title: "开启电动出行新时代上汽大众ID.4X正式投产",
        dec:
          "2020年10月27日，上汽大众ID.4 X投产仪式在位于安亭的新能源汽车工厂举行。随着一辆黄色ID.4 X缓缓驶下生产线，上汽大众首款ID.家族车型正式批量投产。ID.4 X量产下线，意味着上汽大众历时两年建设、股东双方投入超过170亿元的大众汽车集团全球首个专为MEB平台车型生产而新建的工厂正式投产。作为新能源汽车工厂的首款量产车型，ID.4 X的到来亦拉开了上汽大众股东双方加快新能源汽车战略在中国落地的序幕。它也是上汽大众成立以来，累计生产的第2300万零一台整车。",
        imgs: [],
        tourl: "https://www.csvw.com/csvw-website/news/company-news.html?newsid=2876"
      }
    ]
  },
  // 技术亮点
  technology: {
    imageurl: require("../../assets/meb/imgs/jsld/jsldBanner@2x.png"),
    imageurlMobile: require("../../assets/meb/imgsMobile/jsld/mJsldBan@2x.png"),
    imageurl2: require("../../assets/meb/imgs/jsld/sdhxBg@2x.png"),
    imageurl2Mobile: require("../../assets/meb/imgsMobile/jsld/mJsldBg@2x.png"),
    list: [
      {
        videourl: "",
        videoimg: "",
        videoimgMobile: "",
        imageurl: require("../../assets/meb/imgs/jsld/jsldTu6@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu6@2x.png"),
        title: "数字化工厂实现生产“云互联”",
        dec:
          "上汽大众新能源汽车工厂是公司首个实现工业无线网络全覆盖的工厂。车间内布置了大量的AP生产无线热点，结合工业物联网、云存储等互联技术，实现系统集成、数据协同，构建智慧工厂管理平台，打通信息流，实现从设计、生产到销售各个环节的互联互通。<br />工厂不断推进智能工艺优化、设备预防性维护、智能辅助决策等智能技术落地，最终实现全过程智能化生产。",
        imgs: []
      },
      {
        videourl: "",
        videoimg: "",
        videoimgMobile: "",
        imageurl: require("../../assets/meb/imgs/jsld/jsldTu7@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu7@2x.png"),
        title: "环保技术",
        dec:
          "应用可再生能源，如100%直购水电、安装太阳能光伏发电、探索风能应用，使单车二氧化碳排放减少60%；热电联供：以天然气为一次能源，在产生电能的同时利用余热产生蒸汽实现供热，实现了对天然能源的阶梯式利用，使能源利用率最大化，并且大幅减少二氧化碳等温室气体排放，可实现年减碳1.2万吨；120JPH联合油漆车间：新能源汽车工厂的120JPH油漆车间是大众汽车集团全球最大的油漆车间，通过车间联合不仅减少建筑面积，还可节约10%左右的能源。",
        imgs: [
          require("../../assets/meb/imgs/jsld/jsldTu8@2x.png"),
          require("../../assets/meb/imgs/jsld/jsldTu9@2x.png")
        ]
      },
      {
        videourl: "",
        videoimg: "",
        videoimgMobile: "",
        imageurl: require("../../assets/meb/imgs/jsld/jsldTu10@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu10@2x.png"),
        title: "绿色工厂",
        dec:
          "MEB工厂践行大众集团“goTOzero”理念，是上汽大众最绿色环保的工厂。凭借应用可再生能源、热电联供等多项环保、节能技术，被住房和城乡建筑部的绿色建筑设计评审为3星（最高级别），还拿到住建部颁发的绿色建筑设计标识证书。新能源汽车工厂在设计之初就特别关注用地的集约使用，工厂的占地面积是其它相同规模新建工厂的三分之一。",
        imgs: []
      }
    ],
    list2: [
      {
        imageurl: require("../../assets/meb/imgs/jsld/jsldTu1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgsMobile/jsld/mJsldTu0@2x.png"),
        title: "多项先进自动化装备",
        dec:
          "工厂运用多项大众汽车集团首次或国内首次使用的前沿技术，是上汽大众目前最先进、智能的标杆工厂，进一步提升自动化率与生产效率，保障生产品质稳定。",
        imgs: [
          {
            title: "数字化技术",
            dec:
              "建立数字化工厂，对生产制造过程进行虚拟仿真，实现虚拟同步、实时监控。",
            imageurl: require("../../assets/meb/imgs/jsld/jsldTu2@2x.png"),
            imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu2@2x.png"),
          },
          {
            title: "无人化全自动生产",
            dec:
              "工厂采用1400多台工业机器人，具备高度自动化；车身和电池车间基本实现无人化全自动生产。",
            imageurl: require("../../assets/meb/imgs/jsld/jsldTu3@2x.png"),
            imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu3@2x.png"),
          },
          {
            title: "保障产品质量",
            dec:
              "广泛应用高度自动化装配和在线自动测量技术，保障产品质量稳定可靠。",
            imageurl: require("../../assets/meb/imgs/jsld/jsldTu4@2x.png"),
            imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu4@2x.png"),
          },
          {
            title: "大规模科技运用",
            dec:
              "使用各类先进技术和智感装备，实现制造全过程的智能化和数字化。",
            imageurl: require("../../assets/meb/imgs/jsld/jsldTu5@2x.png"),
            imageurlMobile: require("../../assets/meb/imgs/jsld/jsldTu5@2x.png"),
          }
        ]
      }
    ],
    list3: [
      {
        title: "中央监控系统",
        titleEn: "SCADA",
        dec:
          "收集工厂各车间的生产过程中的信息数据，实时监控工厂的生产状态。收集到的数据源会被整合，传输至数据湖储存，实现生产网联化。",
        imageurl: require("../../assets/meb/imgs/jsld/sdhxTu1@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/sdhxTu1@2x.png"),
      },
      {
        title: "智能设备管理系统",
        titleEn: "TPMS",
        dec:
          "利用智能设备可实时监控运行状态，并实现无纸化智能系统管理，将数据进行收集、分析和处理，对设备全生命周期进行全方位数字化管理。",
        imageurl: require("../../assets/meb/imgs/jsld/sdhxTu2@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/sdhxTu2@2x.png"),
      },
      {
        title: "智能生产管理系统",
        titleEn: "PMS",
        dec:
          "通过动态系统化监测管理，实时监控指标管理状态，提升效率。通过电子化流程卡和电子质量管理系统，实时跟踪质量信息，实现质量控制目标。",
        imageurl: require("../../assets/meb/imgs/jsld/sdhxTu3@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/sdhxTu3@2x.png"),
      },
      {
        title: "智能能源管理系统",
        titleEn: "EMS",
        dec:
          "耗能设备上安装智能表具，对工厂5大能种进行动态监测、预警高耗能；利用大数据和云计算，实现精细化管理，在能耗和排产上给出最优策略。",
        imageurl: require("../../assets/meb/imgs/jsld/sdhxTu4@2x.png"),
        imageurlMobile: require("../../assets/meb/imgs/jsld/sdhxTu4@2x.png"),
      }
    ]
  }
}
